"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedEntries = typedEntries;
function typedEntries(obj) {
    return Object.entries(obj);
}
